import { useCallback } from "react"
import { isPlainObject, isFunction } from "lodash"

// to use on ANALYTICS_TRACKING shape
export function useTrack(track) {
  return useCallback((submissionData) => handleTrack(track, submissionData), [track])
}

function handleTrack(track, submissionData) {
  if (!track) return

  let type = track
  let payload = submissionData
  if (isPlainObject(track)) {
    type = track.type
    if (track.payload) {
      if (isPlainObject(track.payload)) {
        payload = track.payload
      } else {
        payload = track.payload(submissionData)
      }
    }
  }

  window.analytics?.track(type, payload)
}

// https://segment.com/docs/connections/spec/track/
export function track(event, properties) {
  if (isFunction(window.analytics?.track)) {
    window.analytics.track(event, properties)
  }
}
